module.exports = __webpack_public_path__ + "explore/images/eoy/bathtub-footer-2x.fd1a5988e12ff7920bb372c7460a0a85.png";